module.exports = __webpack_public_path__ + "static/media/SVG_bookmark.16a42549.svg";